import { extend, setInteractionMode, configure } from 'vee-validate'
import { required, length, email, confirmed, digits, between } from 'vee-validate/dist/rules'
import i18n from '@/i18n'

setInteractionMode('lazy')

configure({
  defaultMessage: (field, values) => {
    // override the field name.
    // values._field_ = i18n.t(`fields.${field}`);
    return i18n.t(`validation.${values._rule_}`, values)
  }
})

// configure({
//   defaultMessage: (field, values) => {
//     // override the field name.
//     // values._field_ = i18n.t(`fields.${field}`);
//     return i18n.t(`validation.${values._rule_}`, values)
//   }
// })

// Install required rule and message.
extend('required', required)

extend('length', length)

extend('email', email)

extend('confirmed', confirmed)

extend('cvv', {
  validate(value) {
    const val = value.replace(/ /g, '')
    return val.length >= 3
  }
})

extend('credit_card', {
  validate(value) {
    const val = value.replace(/ /g, '')
    if (val.length !== 16) return false
    if (val.includes('XXXXXX')) return true
    return luhn(val)
  }
})

extend('kuwait_msisdn', {
  validate(value) {
    const val = value.replace(/ /g, '')
    return val.length === 8
  }
})

extend('pay_amount', {
  validate(value) {
    return !(value < 1 || value > 400)
  }
})

// extend('credit_transfer_amount', {
//   validate(value) {
//     return (Math.round((value * 1000 % 100) * 10000) / 10000) === 0
//   },
//   message: 'credit_transfer_amount should be in increments of 100 fils'
// })
//
// extend('zain_contract', {
//   validate: async (value) => {
//     if (!value) return false
//     try {
//       let { data } = await store.dispatch('callApi', {
//         apiMethod: api.contractValid,
//         args: {
//           contractNumber: value
//         }
//       })
//       return data.isValid
//     } catch (e) {
//       console.error(e)
//       return false
//     }
//   }
// })

// extend('zain_msisdn', {
//   validate: async (value) => {
//     if (!value) return false
//     if (value.length !== 8) return false
//     try {
//       let { data } = await store.dispatch('callApi', {
//         apiMethod: api.subscriberTypeQuery,
//         args: {
//           msisdn: value,
//           contractNumber: 'anonymous'
//         }
//       })
//       return !!data
//     } catch (e) {
//       console.error(e)
//       return false
//     }
//   }
// })

// extend('zain_prepaid_msisdn', {
//   validate: async (value) => {
//     value = value.toString()
//     console.log(value.length, value)
//     if (!value) return false
//     if (value.length !== 8) return false
//     try {
//       let { data } = await store.dispatch('callApi', {
//         apiMethod: api.subscriberTypeQuery,
//         args: {
//           msisdn: value,
//           contractNumber: 'anonymous'
//         }
//       })
//       console.log(data)
//       return data && data?.BillingType === 'Prepaid'
//     } catch (e) {
//       console.error(e)
//       return false
//     }
//   }
// })

function luhn(identifier) {
  let sum = 0
  let alt = false
  let i = identifier.length - 1
  let num

  while (i >= 0) {
    num = parseInt(identifier.charAt(i), 10)

    if (alt) {
      num *= 2
      if (num > 9) {
        num = (num % 10) + 1
      }
    }
    alt = !alt
    sum += num
    i--
  }

  return sum % 10 === 0
}

extend('digits', digits)

extend('between', between)

extend('not_the_same', {
  params: ['target'],
  validate(value, { target }) {
    return value !== target
  }
})


extend('kuwait_civil_id', {
  validate(value) {
    const civilId = value
    if (!civilId) return false
    if (!(/^\d+$/.test(civilId))) return false
    if (civilId.length !== 12) return false
    let month = parseInt(civilId.substr(3, 2))
    let day = parseInt(civilId.substr(5, 2))
    if ((month > 12 || month < 1) || (day > 31 || day < 1)) return false
    let coEff = [2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
    let checkDigit = 0
    for (let i = 0; i < 11; i++) checkDigit += parseInt(civilId[i]) * coEff[i]
    return (11 - checkDigit % 11) === parseInt(civilId.substr(11, 1))
  }
})

// named must so that the pink asterisk doesn't show in input fields
extend('eezee_must', required)

extend('eezee_civil_id', {
  validate(value) {
    const civilId = value
    if (!civilId) return false
    if (!(/^\d+$/.test(civilId))) return false
    if (civilId.length !== 12) return false
    let month = parseInt(civilId.substr(3, 2))
    let day = parseInt(civilId.substr(5, 2))
    if ((month > 12 || month < 1) || (day > 31 || day < 1)) return false
    let coEff = [2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
    let checkDigit = 0
    for (let i = 0; i < 11; i++) checkDigit += parseInt(civilId[i]) * coEff[i]
    return (11 - checkDigit % 11) === parseInt(civilId.substr(11, 1))
  }
})

extend('civil_id_over_18', {
  validate(value) {
    const currentYear = (new Date()).getFullYear()
    const civilId = value
    const yearLastTwoDigits = civilId.substring(1, 3)
    const yearPrefix = civilId.substring(0, 1)
    let year
    if (yearPrefix === '2') {
      year = parseInt(`19${ yearLastTwoDigits }`)
    } else {
      year = parseInt(`20${ yearLastTwoDigits }`)
    }
    const age = currentYear - year
    return age > 18
  }
})
